import { ChangeEventHandler } from 'react';
import { onlyNum } from '../../../lib/funcs';
import InputGroup from '../InputGroup';
import { useLanguage } from '../../../lib/LanguageContext';

interface IPipsInput {
  pips: string | number,
  setPips: React.Dispatch<React.SetStateAction<number|string>>;
  className?: string;
}

function PipsInput({ pips, setPips, className }: IPipsInput) {
  const pipsChanged: ChangeEventHandler<HTMLInputElement> = (e) => {
    setPips(onlyNum(e.target.value));
  }
  const { languageData } = useLanguage();
  return (
    <div className={className || "col-12"}>
      <InputGroup type="text" label={languageData.pips} value={pips || ''} onChange={pipsChanged} />
    </div>
  );
}

export default PipsInput;
